import { CostPreference, DietaryRestriction, LanguagePreference } from "@/api/reservation/dto";
import { useGetReservationQuestions } from "@/api/reservation/useGetReservationQuestions";
import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useGetMyLatestReservation } from "@/api/user/useGetMyUpcomingReservations";
import { Error } from "@/components/Error";
import { EventReservation } from "@/components/EventReservation/EventReservation";
import { Center, Text } from "@mantine/core";
import { Navigate } from "react-router-dom";

export interface EventReservationFormValues {
  event: {
    preferredTimes: string[];
    preferredLocationIds: string[];
    messageForGuests: string;
  };
  dinnerPreference: {
    preferredLanguage: LanguagePreference | "";
    preferredCost: CostPreference | "";
    dietaryRestrictions: DietaryRestriction[];
    dietaryRestrictionsOtherText?: string;
  };
}

export function EventReservationPage() {
  const { data: eventQuestions, isLoading: isLoadingQuestions } = useGetReservationQuestions();
  const { data: latestReservation, isLoading: isLoadingLatestReservation } =
    useGetMyLatestReservation();
  const {
    data: userSummary,
    isLoading: isUserSummaryLoading,
    isError: isUserSummaryError,
    isSuccess: isUserSummarySuccess,
  } = useGetMySummary();

  if (isUserSummarySuccess && !userSummary?.hasCompletedPersonalityTest) {
    return <Navigate to="/personality-test" />;
  }

  if (isLoadingQuestions || isUserSummaryLoading || isLoadingLatestReservation) {
    return (
      <Center h="100%">
        <Text>Loading...</Text>
      </Center>
    );
  }

  if (isUserSummaryError) {
    return <Error />;
  }

  if (!eventQuestions || eventQuestions.length === 0) {
    return (
      <Center h="100%">
        <Text>No event questions available at the moment.</Text>
      </Center>
    );
  }

  return (
    <EventReservation
      eventQuestions={eventQuestions}
      latestReservation={latestReservation ?? null}
    />
  );
}
